/**
 * Storage Utility
 * LocalStorage wrapper for compatibility with old codebase
 * Based on Storage.js from ibitplay
 */

class Storage {
  /**
   * Set a key-value pair in localStorage
   * @param {string} key
   * @param {*} value
   */
  setKey(key, value) {
    try {
      if (value === null || value === undefined) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (err) {
      console.error('Error setting storage key:', err);
    }
  }

  /**
   * Get a value from localStorage
   * @param {string} key
   * @returns {*}
   */
  getKey(key) {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return null;
      return JSON.parse(raw);
    } catch (err) {
      // If parsing fails, return raw value (for backward compatibility)
      return localStorage.getItem(key);
    }
  }

  /**
   * Remove a key from localStorage
   * @param {string} key
   */
  removeKey(key) {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.error('Error removing storage key:', err);
    }
  }

  /**
   * Clear all localStorage
   */
  clear() {
    try {
      localStorage.clear();
    } catch (err) {
      console.error('Error clearing storage:', err);
    }
  }
}

// Export singleton instance
const storage = new Storage();
export default storage;
